import React from 'react';

export const ExpandUpper = ({
  className,
  color,
  height,
}: {
  className?: string;
  color?: string;
  height?: string;
}) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_56_9346"
      className="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="14"
      height="15"
    >
      <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_56_9346)">
      <path
        d="M5.19167 8.72516L4.375 9.54183L7 12.1668L9.625 9.54183L8.80833 8.72516L7 10.5335L5.19167 8.72516ZM7 2.8335L4.375 5.4585L5.19167 6.27516L7 4.46683L8.80833 6.27516L9.625 5.4585L7 2.8335Z"
        fill="#7D7A9A"
      />
    </g>
  </svg>
);
